import { Component, OnInit, Inject,ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { lang_ods } from 'app/idiomas/i18n/ods-v2/ods.lang';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_calend } from 'app/idiomas/i18n/calend-survey/calend.lang';
import Swal from 'sweetalert2';
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from '@fuse/animations';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { DateAdapter } from '@angular/material/core';
const moment = require('moment');
const momentTz = require('moment-timezone');

@Component({
  selector: 'modal-calend-info',
  templateUrl: './modal-calend-info.component.html',
  styleUrls: ['./modal-calend-info.component.scss'],
  animations : fuseAnimations
})
export class ModalCalendInfoComponent implements OnInit {

idiomaActual:string;
  constructor(
  @Inject(MAT_DIALOG_DATA) public datos: any,
  public dialogRef: MatDialogRef<ModalCalendInfoComponent>,
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  private translateSrv: TranslateService,
  private snackBar: MatSnackBar,
  private dateAdapter: DateAdapter<Date>
) {
  this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  lang_calend.forEach((locale) => {
    this._fuseTranslationLoaderService.loadTranslations(locale);
  });
  this.idiomaActual = this.translateSrv.currentLang;

}


  ngOnInit() {
    console.log("Datos",this.datos);


  }


  modalGuardado(){
    let mensaje: string;

        this.translateSrv.get('CONFING_RESUL.MODAL_GUA_INFOR').subscribe((res: string) => { mensaje = res; });
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }

  openSuccessSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['background-success']
     });
  }

    mensajeSwal(mensaje:string, tipoMsg:number){
      let tipo: any;
      let rspSi = 'MODALES.ACCIONES.aceptar';
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      switch(tipoMsg){
        case 1: tipo = 'success'; break;
        case 2: tipo = 'warning'; break;
        case 3: tipo = 'error'; break;
      }
      Swal.fire({
        title: mensaje,
        icon: tipo,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
}
